(function () {
  const body = document.body;
  if (
    !body.classList.contains('jlore-home') &&
    !body.classList.contains('jlore-collection') &&
    !body.classList.contains('jlore-story')
  ) {
    return;
  }

  const onScroll = function () {
    body.classList.toggle('jlore-header-scrolled', window.scrollY > 48);
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
